import { DynamicValue, HeaderNavContext } from '../interfaces';

const resolveValue = <T>(
    value: DynamicValue<T> | undefined,
    ctx: HeaderNavContext,
): T | undefined => {
    if (typeof value === 'function') {
        return (value as (ctx: HeaderNavContext) => T)(ctx);
    }

    return value;
};

export default resolveValue;
